import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TheMainContent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true, }
}

})